export var GdsgInventoryReportCsvRecordSeparator;
(function (GdsgInventoryReportCsvRecordSeparator) {
    GdsgInventoryReportCsvRecordSeparator["GDSG_INVENTORY_REPORT_CSV_RECORD_SEPARATOR_LF"] = "LF";
    GdsgInventoryReportCsvRecordSeparator["GDSG_INVENTORY_REPORT_CSV_RECORD_SEPARATOR_CRLF"] = "CRLF";
})(GdsgInventoryReportCsvRecordSeparator || (GdsgInventoryReportCsvRecordSeparator = {}));
